import { createClientComponentClient } from '@supabase/auth-helpers-nextjs'
import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/types/supabase'

// Environment variables
const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

// Export types
export type SupabaseClient = ReturnType<typeof createClientComponentClient<Database>>
export type SupabaseApiClient = ReturnType<typeof createClient>

// Create and export a single instance for client components
export const supabase = createClientComponentClient<Database>()

// Export the function to get the Supabase client
export const getSupabaseClient = () => supabase